import { Box, Typography, Chip } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { Booking, BookingStatus } from "src/business/booking";
import { BookingListItem } from "./BookingListItem";
import {
  colorTextPrimary,
  colorTextMuted,
  colorBorder,
  colorSurface,
  radiusCard,
  shadowCard,
  colorBackgroundInfo,
  colorTextInfo,
  colorBorderInfo,
} from "src/design/tokens";
import { useTranslation } from "react-i18next";

interface Props {
  dateLabel: string;
  bookings: Booking[];
  onStatusChange: (booking: Booking, status: BookingStatus) => void;
  isBookingUpdateEnabled: boolean;
  restaurantName: string;
}

export const BookingDateGroup = ({
  dateLabel,
  bookings,
  onStatusChange,
  isBookingUpdateEnabled,
  restaurantName,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
        <CalendarTodayOutlinedIcon
          sx={{ fontSize: 14, color: colorTextMuted }}
        />
        <Typography
          sx={{ fontWeight: 600, fontSize: "14px", color: colorTextPrimary }}
        >
          {dateLabel}
        </Typography>
        <Chip
          label={t("bookings.list.bookingsCount", { count: bookings.length })}
          size="small"
          sx={{
            fontSize: "11px",
            height: "20px",
            backgroundColor: colorBackgroundInfo,
            color: colorTextInfo,
            border: `1px solid ${colorBorderInfo}`,
            borderRadius: "6px",
          }}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: colorSurface,
          border: `1px solid ${colorBorder}`,
          borderRadius: radiusCard,
          boxShadow: shadowCard,
          overflow: "hidden",
        }}
      >
        {bookings.map((booking) => (
          <BookingListItem
            key={booking.id}
            booking={booking}
            onStatusChange={onStatusChange}
            isBookingUpdateEnabled={isBookingUpdateEnabled}
            restaurantName={restaurantName}
          />
        ))}
      </Box>
    </Box>
  );
};
